module.exports = __webpack_public_path__ + "img/landing-page-lightbulb.120f5d3a.svg";